namespace advisorop.components.servicer {

    interface IInvestorNavController {
        $router;
    }

    class InvestorNavController implements IInvestorNavController {

        $router;

        static $inject = ["identityService"];
        constructor(private identityService: services.IdentityService) {

        }

        logout(): void {
            this.$router.parent.navigate(["Account", "Logout"]);
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }



    class InvestorNav implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                //textBinding: '@',
                //dataBinding: '<',
                //functionBinding: '&'
                "$router": "<"
            };
            this.controller = InvestorNavController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/investor-nav.html';
        }
    }
    angular.module(Constants.APP).component("investorNav", new InvestorNav());


}